/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';

import { apiVoxtralScheduleBroadcastKeyDelete } from '../fn/voxtral-schedule/api-voxtral-schedule-broadcast-key-delete';
import { ApiVoxtralScheduleBroadcastKeyDelete$Params } from '../fn/voxtral-schedule/api-voxtral-schedule-broadcast-key-delete';
import { apiVoxtralScheduleBroadcastKeyPost } from '../fn/voxtral-schedule/api-voxtral-schedule-broadcast-key-post';
import { ApiVoxtralScheduleBroadcastKeyPost$Params } from '../fn/voxtral-schedule/api-voxtral-schedule-broadcast-key-post';
import { apiVoxtralScheduleGet } from '../fn/voxtral-schedule/api-voxtral-schedule-get';
import { ApiVoxtralScheduleGet$Params } from '../fn/voxtral-schedule/api-voxtral-schedule-get';

@Injectable({ providedIn: 'root' })
export class VoxtralScheduleService extends BaseService {
  constructor(config: ApiConfiguration, http: HttpClient) {
    super(config, http);
  }

  /** Path part for operation `apiVoxtralScheduleBroadcastKeyPost()` */
  static readonly ApiVoxtralScheduleBroadcastKeyPostPath = '/api/voxtral-schedule/{broadcastKey}';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiVoxtralScheduleBroadcastKeyPost()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiVoxtralScheduleBroadcastKeyPost$Response(params: ApiVoxtralScheduleBroadcastKeyPost$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
    return apiVoxtralScheduleBroadcastKeyPost(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiVoxtralScheduleBroadcastKeyPost$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiVoxtralScheduleBroadcastKeyPost(params: ApiVoxtralScheduleBroadcastKeyPost$Params, context?: HttpContext): Observable<void> {
    return this.apiVoxtralScheduleBroadcastKeyPost$Response(params, context).pipe(
      map((r: StrictHttpResponse<void>): void => r.body)
    );
  }

  /** Path part for operation `apiVoxtralScheduleBroadcastKeyDelete()` */
  static readonly ApiVoxtralScheduleBroadcastKeyDeletePath = '/api/voxtral-schedule/{broadcastKey}';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiVoxtralScheduleBroadcastKeyDelete()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiVoxtralScheduleBroadcastKeyDelete$Response(params: ApiVoxtralScheduleBroadcastKeyDelete$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
    return apiVoxtralScheduleBroadcastKeyDelete(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiVoxtralScheduleBroadcastKeyDelete$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiVoxtralScheduleBroadcastKeyDelete(params: ApiVoxtralScheduleBroadcastKeyDelete$Params, context?: HttpContext): Observable<void> {
    return this.apiVoxtralScheduleBroadcastKeyDelete$Response(params, context).pipe(
      map((r: StrictHttpResponse<void>): void => r.body)
    );
  }

  /** Path part for operation `apiVoxtralScheduleGet()` */
  static readonly ApiVoxtralScheduleGetPath = '/api/voxtral-schedule';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiVoxtralScheduleGet()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiVoxtralScheduleGet$Response(params?: ApiVoxtralScheduleGet$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
    return apiVoxtralScheduleGet(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiVoxtralScheduleGet$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiVoxtralScheduleGet(params?: ApiVoxtralScheduleGet$Params, context?: HttpContext): Observable<void> {
    return this.apiVoxtralScheduleGet$Response(params, context).pipe(
      map((r: StrictHttpResponse<void>): void => r.body)
    );
  }

}
